export default __webpack_public_path__ + "static/mockup1_0_inspection_settings-a190a879cfa98dada9df5773867199bb.png";